// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/rfi_feedback.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { RfiPackageVersion, RfiSubmission } from "./rfi_packages_pb";
/**
 * @generated from message mono.datagateway.v1.RfiFeedbackVersion
 */ export class RfiFeedbackVersion extends Message {
    static fromBinary(bytes, options) {
        return new RfiFeedbackVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiFeedbackVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiFeedbackVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiFeedbackVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string submission_id = 3;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string package_id = 4;
   */ _define_property(this, "packageId", ""), /**
   * @generated from field: string prior_version_id = 5;
   */ _define_property(this, "priorVersionId", ""), /**
   * @generated from field: int32 version = 6;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string request_id = 7;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string body = 8;
   */ _define_property(this, "body", ""), /**
   * @generated from field: string actor_user_id = 9;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiFeedbackVersion, "runtime", proto3);
_define_property(RfiFeedbackVersion, "typeName", "mono.datagateway.v1.RfiFeedbackVersion");
_define_property(RfiFeedbackVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "package_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "prior_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiFeedbackAdoption
 */ export class RfiFeedbackAdoption extends Message {
    static fromBinary(bytes, options) {
        return new RfiFeedbackAdoption().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiFeedbackAdoption().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiFeedbackAdoption().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiFeedbackAdoption, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string source_version_id = 3;
   */ _define_property(this, "sourceVersionId", ""), /**
   * @generated from field: string capture_project_id = 4;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string target_kind = 5;
   */ _define_property(this, "targetKind", ""), /**
   * @generated from field: string target_id = 6;
   */ _define_property(this, "targetId", ""), /**
   * @generated from field: string target_field = 7;
   */ _define_property(this, "targetField", ""), /**
   * @generated from field: string before_version_id = 8;
   */ _define_property(this, "beforeVersionId", ""), /**
   * @generated from field: string result_version_id = 9;
   */ _define_property(this, "resultVersionId", ""), /**
   * @generated from field: string before_text = 10;
   */ _define_property(this, "beforeText", ""), /**
   * @generated from field: string proposed_text = 11;
   */ _define_property(this, "proposedText", ""), /**
   * @generated from field: string request_id = 12;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string actor_user_id = 13;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp adopted_at = 14;
   */ _define_property(this, "adoptedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiFeedbackAdoption, "runtime", proto3);
_define_property(RfiFeedbackAdoption, "typeName", "mono.datagateway.v1.RfiFeedbackAdoption");
_define_property(RfiFeedbackAdoption, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "target_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "target_field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "before_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "result_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "before_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "proposed_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "adopted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiFeedbackHistory
 */ export class RfiFeedbackHistory extends Message {
    static fromBinary(bytes, options) {
        return new RfiFeedbackHistory().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiFeedbackHistory().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiFeedbackHistory().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiFeedbackHistory, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: repeated mono.datagateway.v1.RfiSubmission submissions = 3;
   */ _define_property(this, "submissions", []), /**
   * @generated from field: repeated mono.datagateway.v1.RfiFeedbackVersion versions = 4;
   */ _define_property(this, "versions", []), /**
   * @generated from field: repeated mono.datagateway.v1.RfiFeedbackAdoption adoptions = 5;
   */ _define_property(this, "adoptions", []), /**
   * @generated from field: string zou_project_id = 6;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.RfiPackageVersion package_versions = 7;
   */ _define_property(this, "packageVersions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiFeedbackHistory, "runtime", proto3);
_define_property(RfiFeedbackHistory, "typeName", "mono.datagateway.v1.RfiFeedbackHistory");
_define_property(RfiFeedbackHistory, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "submissions",
            kind: "message",
            T: RfiSubmission,
            repeated: true
        },
        {
            no: 4,
            name: "versions",
            kind: "message",
            T: RfiFeedbackVersion,
            repeated: true
        },
        {
            no: 5,
            name: "adoptions",
            kind: "message",
            T: RfiFeedbackAdoption,
            repeated: true
        },
        {
            no: 6,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "package_versions",
            kind: "message",
            T: RfiPackageVersion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordRfiFeedbackVersionRequest
 */ export class RecordRfiFeedbackVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordRfiFeedbackVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordRfiFeedbackVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordRfiFeedbackVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordRfiFeedbackVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Principal tenant always takes precedence.
   *
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string submission_id = 3;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string prior_version_id = 4;
   */ _define_property(this, "priorVersionId", ""), /**
   * @generated from field: string body = 5;
   */ _define_property(this, "body", ""), /**
   * @generated from field: string request_id = 6;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordRfiFeedbackVersionRequest, "runtime", proto3);
_define_property(RecordRfiFeedbackVersionRequest, "typeName", "mono.datagateway.v1.RecordRfiFeedbackVersionRequest");
_define_property(RecordRfiFeedbackVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "prior_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordRfiFeedbackVersionResponse
 */ export class RecordRfiFeedbackVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordRfiFeedbackVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordRfiFeedbackVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordRfiFeedbackVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordRfiFeedbackVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiFeedbackVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordRfiFeedbackVersionResponse, "runtime", proto3);
_define_property(RecordRfiFeedbackVersionResponse, "typeName", "mono.datagateway.v1.RecordRfiFeedbackVersionResponse");
_define_property(RecordRfiFeedbackVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: RfiFeedbackVersion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AdoptRfiFeedbackRequest
 */ export class AdoptRfiFeedbackRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdoptRfiFeedbackRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdoptRfiFeedbackRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdoptRfiFeedbackRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdoptRfiFeedbackRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string source_version_id = 3;
   */ _define_property(this, "sourceVersionId", ""), /**
   * @generated from field: string capture_project_id = 4;
   */ _define_property(this, "captureProjectId", ""), /**
   * customer_theme | solution_item | solution_component
   *
   * @generated from field: string target_kind = 5;
   */ _define_property(this, "targetKind", ""), /**
   * @generated from field: string target_id = 6;
   */ _define_property(this, "targetId", ""), /**
   * narrative | text | proposed_approach, respectively
   *
   * @generated from field: string target_field = 7;
   */ _define_property(this, "targetField", ""), /**
   * @generated from field: string expected_target_version_id = 8;
   */ _define_property(this, "expectedTargetVersionId", ""), /**
   * @generated from field: string proposed_text = 9;
   */ _define_property(this, "proposedText", ""), /**
   * @generated from field: string request_id = 10;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdoptRfiFeedbackRequest, "runtime", proto3);
_define_property(AdoptRfiFeedbackRequest, "typeName", "mono.datagateway.v1.AdoptRfiFeedbackRequest");
_define_property(AdoptRfiFeedbackRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "target_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "target_field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "expected_target_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "proposed_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AdoptRfiFeedbackResponse
 */ export class AdoptRfiFeedbackResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdoptRfiFeedbackResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdoptRfiFeedbackResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdoptRfiFeedbackResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdoptRfiFeedbackResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiFeedbackAdoption adoption = 1;
   */ _define_property(this, "adoption", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdoptRfiFeedbackResponse, "runtime", proto3);
_define_property(AdoptRfiFeedbackResponse, "typeName", "mono.datagateway.v1.AdoptRfiFeedbackResponse");
_define_property(AdoptRfiFeedbackResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "adoption",
            kind: "message",
            T: RfiFeedbackAdoption
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRfiFeedbackHistoryRequest
 */ export class GetRfiFeedbackHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiFeedbackHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiFeedbackHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiFeedbackHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiFeedbackHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiFeedbackHistoryRequest, "runtime", proto3);
_define_property(GetRfiFeedbackHistoryRequest, "typeName", "mono.datagateway.v1.GetRfiFeedbackHistoryRequest");
_define_property(GetRfiFeedbackHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRfiFeedbackHistoryResponse
 */ export class GetRfiFeedbackHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiFeedbackHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiFeedbackHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiFeedbackHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiFeedbackHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiFeedbackHistory history = 1;
   */ _define_property(this, "history", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiFeedbackHistoryResponse, "runtime", proto3);
_define_property(GetRfiFeedbackHistoryResponse, "typeName", "mono.datagateway.v1.GetRfiFeedbackHistoryResponse");
_define_property(GetRfiFeedbackHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "history",
            kind: "message",
            T: RfiFeedbackHistory
        }
    ]));
/**
 * Authorization-only callback contract for the forthcoming zou facade:
 * mono.projectdata.v1.RfiFeedbackService/CheckRfiFeedbackAccess.
 * No content, actor or tenant is accepted; use the forwarded principal.
 * record: RFI update + sensitive. adopt: RFI read + sensitive and Pursuit
 * update + sensitive. history: RFI read + sensitive. Deny unknown actions.
 *
 * @generated from message mono.datagateway.v1.CheckRfiFeedbackAccessRequest
 */ export class CheckRfiFeedbackAccessRequest extends Message {
    static fromBinary(bytes, options) {
        return new CheckRfiFeedbackAccessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckRfiFeedbackAccessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckRfiFeedbackAccessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckRfiFeedbackAccessRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * record | adopt | history
   *
   * @generated from field: string action = 3;
   */ _define_property(this, "action", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckRfiFeedbackAccessRequest, "runtime", proto3);
_define_property(CheckRfiFeedbackAccessRequest, "typeName", "mono.datagateway.v1.CheckRfiFeedbackAccessRequest");
_define_property(CheckRfiFeedbackAccessRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CheckRfiFeedbackAccessResponse
 */ export class CheckRfiFeedbackAccessResponse extends Message {
    static fromBinary(bytes, options) {
        return new CheckRfiFeedbackAccessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckRfiFeedbackAccessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckRfiFeedbackAccessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckRfiFeedbackAccessResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckRfiFeedbackAccessResponse, "runtime", proto3);
_define_property(CheckRfiFeedbackAccessResponse, "typeName", "mono.datagateway.v1.CheckRfiFeedbackAccessResponse");
_define_property(CheckRfiFeedbackAccessResponse, "fields", proto3.util.newFieldList(()=>[]));
